import './driverSummary.css';
import Placeholder from "../../../shared/placeholder/placeholder";

const DriversSummary = ({summary, distanceLoader = false, summaryLoader = false}) => {
    return (
        <>
            <div className={'accordion-sec expand'}>
                <div className="accordion-head padding-tb-10 sf-medium">
                    <div className="head-content flex gap-40">

                    </div>
                    <div className="more-less-btn"></div>
                </div>
                <div className='accordion-content padding-tb-20'>
                    <ul className={'driver-summary flex hr-space-between align-top gap-10'}>
                        {distanceLoader &&
                            <li className={'round-corner-8'}><Placeholder width={'140px'} height={'75px'}/></li>
                        }
                        {!summaryLoader && summary?.alerts?.length > 0 &&
                            summary?.alerts?.map((alert, index) =>
                                (alert?.value &&
                                    <li key={alert.id} className="alert page-fade-in">
                                        <div
                                            className={`number sf-medium ${alert?.value > 10 ? 'red-color' : 'green-color'}`}>{alert?.value}</div>
                                        <div className="name sf-medium">{alert['tooltip_name']}</div>
                                    </li>
                                )
                            )
                        }
                        {summaryLoader &&
                            [1, 2, 3, 4, 5].map((index) =>
                                <li key={index} className={'round-corner-8'}><Placeholder width={'140px'}
                                                                                          height={'75px'}/></li>
                            )}

                    </ul>
                </div>
            </div>

        </>
    )
}

export default DriversSummary;
